<app-input
  label="Efficiency"
  placeholder="Optional..."
  [value]="part.efficiency"
  [unit]="UnitType.RATIO"
  [type]="InputTypes.NUMBER"
  [id]="part.component_type+'_efficiency'"
  [updater]="update"
  [readOnly]="readonly"
  (update)="setPart.emit([''+$event, 'efficiency', part.component_type+'_efficiency'])"></app-input>
  <div class="two-col-inputs">
    <app-input
      label="Cost"
      placeholder="Optional..."
      [value]="part.cost"
      [type]="InputTypes.NUMBER"
      [id]="part.component_type+'_cost'"
      [updater]="update"
      [readOnly]="readonly"
      (update)="setPart.emit([''+$event, 'cost', part.component_type+'_cost'])"></app-input>
    <app-input
      label="Mass"
      placeholder="Optional..."
      [value]="part.mass"
      [unit]="UnitType.MASS"
      [type]="InputTypes.NUMBER"
      [id]="part.component_type+'_mass'"
      [updater]="update"
      [readOnly]="readonly"
      (update)="setPart.emit([''+$event, 'mass', part.component_type+'_mass'])"></app-input>
  </div>
